import { combineReducers } from 'redux';
import activities from './activities';

const reducers = { activities };
export default combineReducers(reducers);
